module.exports = __webpack_public_path__ + "d6c8e8dfcdafd9e64fb3b92f6e99d395.svg";